import { apiRequest } from "@/services/api-client";
import { InventoryItemsOutput } from "types/web-app";

export const listInventoryItems = () =>
  apiRequest<InventoryItemsOutput>("/inventory-items");
